import { render, staticRenderFns } from "./infoArea03.vue?vue&type=template&id=4f5e0b74"
import script from "./infoArea03.vue?vue&type=script&lang=js"
export * from "./infoArea03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports